<template>
  <el-tag v-if="text" type="info" :hit="true" size="small">
    {{ text }}
  </el-tag>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { ProtocolLabels, ProtocolLabel } from '@/api/types'
export default defineComponent({
  name: 'ProtocolLabel',
  props: {
    type: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const text = computed(() => {
      const label = ProtocolLabels.find(
        (x: ProtocolLabel) => x.type_id === props.type
      )
      return label ? label.label : null
    })
    return { text }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  margin-left: 5px;
  border: none !important;
}
</style>
